import type { ComponentType } from 'react'
import ContentLoader from './global/loaders/ContentLoader'

interface FeatureFlaggedRouteProps {
  decision: { status: 'loading' } | { status: 'error'; retry: () => unknown } | { status: 'ready'; enabled: boolean }
  enabledComponent: ComponentType<Record<string, unknown>>
  fallbackComponent: ComponentType<Record<string, unknown>>
  componentProps?: Record<string, unknown>
}

const FeatureFlaggedRoute = ({
  decision,
  enabledComponent: EnabledComponent,
  fallbackComponent: FallbackComponent,
  componentProps = {}
}: FeatureFlaggedRouteProps) => {
  if (decision.status === 'error') {
    return (
      <div role="alert">
        Could not load checkout options. <button onClick={decision.retry}>Retry</button>
      </div>
    )
  }

  if (decision.status === 'loading') {
    return <ContentLoader />
  }

  if (decision.enabled) {
    return <EnabledComponent {...componentProps} />
  }

  return <FallbackComponent {...componentProps} />
}

export default FeatureFlaggedRoute
